import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, RouteProps } from 'react-router-dom';
import { WebRoutes } from '../../enums/routerPath';
import { RootState } from '../../store/rootReducer';
import { IPageProps, Page } from '../page';

export interface IPaymentSuccessRouteProps extends RouteProps {
	redirectPath?: string;
}

export const PaymentSuccessRoute: React.FC<IPaymentSuccessRouteProps & IPageProps> = ({ title, redirectPath, component, ...props }) => {
	const paymentSuccess = useSelector((state: RootState) => state.paymentForm.paymentSuccess);
	return paymentSuccess ? <Page title={title} {...props} component={component} /> : <Redirect to={redirectPath ?? WebRoutes.HOME.path} />;
};
